export default __webpack_public_path__ + "static/media/dtsu5168_direct_master_4p.a80b7020.png";